import React, { useState, useEffect  }  from "react";
//import * as THREE from "three";
//import { Text as TroikaText } from "troika-three-text";
import { getAuth, isSignInWithEmailLink } from 'firebase/auth';
import { VMAuthStorage } from './voteMachine/vmAuthStorage';
import { VMHome } from "./voteMachine/vmHome";
import VMReport  from "./voteMachine/vmReport";
import { VMManual } from "./voteMachine/vmManual";
import { VMAuthPanel } from "./voteMachine/vmAuthPanel";
import { useAuth } from './voteMachine/vmAuthenticate';
import { SlidingPanelSystem } from "./voteMachine/vmSlidingPanel";
//import "./votemachine.active.scss";
import "./votemachine.scss";
import drawer_open from './sounds/drawer_open.mp3';


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function VMDashboardContainer() {
  return (
    <div className="vm-dashboard-container">
      <VMDashboard ></VMDashboard>
    </div>
  );
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function VMDashboard() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex justify-center">
      <AuthRedirectHandler />
      <VMMainPanel onMessage={null} />
    </div>
  );
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function VMMainPanel({ onMessage }) {
  const [activeSection, setActiveSection] = useState('manual');
  const { user, isLoading, isAuthenticated } = useAuth();
  const userId = user?.userId;

  const drawer_sound = new Audio(drawer_open);
  drawer_sound.volume = 0.75;

  const changeSection = (sectionId) => {
    console.log("changeSection called with:", sectionId);
    setActiveSection(sectionId);
    if (sectionId === 'home') {
      setContent(<VMHome  />);
    }
  };

  const [content, setContent] = useState(<VMHome />);

  const sections = [
    { id: 'home', label: 'Home', component: <VMHome  /> },
    { id: 'reports', label: 'Reports', component: <VMReport  /> },
    { id: 'manual', label: 'Manual', component:  <SlidingPanelSystem initialPanel={<VMManual changeSection={changeSection}/>} />}
  ];

  useEffect(() => {
    console.log("Setting initial content, userId:", userId);
    console.log("isLoading: " + isLoading + " isAuthenticated: " + isAuthenticated);
    if (!isLoading) {
      if (!isAuthenticated) {
        setContent(<SlidingPanelSystem initialPanel={<VMManual changeSection={changeSection}/>} />);
        setActiveSection('manual');
      } else {
        setContent(<VMHome/>);
        setActiveSection('home');
      }
    }
  }, [userId, isLoading, isAuthenticated]);


  const handleSectionChange = (sectionId) => {
    if (activeSection === sectionId && sectionId !== 'home') return;

    if (!isAuthenticated && (sectionId === 'home' || sectionId === 'reports')) {
      console.log("User is not authenticated, redirecting to sign in");
      setContent(<SlidingPanelSystem initialPanel={<VMAuthPanel changeSection={changeSection}/>} />);
      setActiveSection('manual');
      return;
    }

    drawer_sound.currentTime = 0;
    drawer_sound.play().catch(error => {
      console.log('Sound playback failed:', error);
    });

    const clipper = document.getElementById('vm-clipper');
    clipper.style.transform = 'translateX(-120%)';
    
    setTimeout(() => {
      setActiveSection(sectionId);
      // For home section, always create a fresh instance with a new key
      if (sectionId === 'home') {
        setContent(<VMHome key={Date.now()} />);
      } else {
        setContent(sections.find(section => section.id === sectionId).component);
      }
      clipper.style.transform = 'translateX(0%)';
    }, 450);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

      /*
      */

  return (
    <div className="flex justify-center">
      <div className="vm-header-button-container">
        {sections.map(section => (
          <button 
            key={section.id}
            className={activeSection === section.id ? "vm-header-button-active" : "vm-header-button"}
            onClick={() => handleSectionChange(section.id)}
          >
            {section.label}
          </button>
        ))}
      </div>
      <div className="vm-main-panel" id="vm-main-panel">
        <div className="vm-clipper" id="vm-clipper">
          {content}
        </div>
      </div>
    </div>
  );
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const AuthRedirectHandler = () => {
  useEffect(() => {
    const handleAuthRedirect = async () => {
      const auth = getAuth();
      const href = window.location.href;

      console.log("Checking for auth redirect, href:", href);
      try {
        if (isSignInWithEmailLink(auth, href)) {
          console.log("Detected email sign-in link");
          // Save the full URL before doing anything else
          VMAuthStorage.setPendingAuthUrl(href);
          // Check if we have the email in storage
          const email = VMAuthStorage.getSignInEmail();
          if (!email) {
            console.error("No email found in storage for sign-in link");
            return;
          }
          console.log("Found stored email:", email);
          // Log the current state
          VMAuthStorage.logAuthState();
          // Only replace the URL after we've saved what we need
          const baseUrl = window.location.origin + window.location.pathname;
          console.log("Redirecting to base URL:", baseUrl);
          window.location.replace(baseUrl);
        } else {
          console.log("Not an email sign-in link");
        }
      } catch (error) {
        console.error("Error in AuthRedirectHandler:", error);
      }
    };

    handleAuthRedirect();
  }, []);

  return null;
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/*
function smoothScroll(element, to, duration) {
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;

  function animateScroll() {
    currentTime += 16; // Update every 16 milliseconds (approx 60 frames per second)
    const easing = Math.sin(currentTime / duration * (Math.PI / 2)); // You can use different easing functions

    element.scrollTop = start + change * easing;

    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    }
  }

  animateScroll();
}*/
